export const PAYMENT_DUE_DAYS_LIMIT = 2;
